import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-center" }
const _hoisted_2 = { class: "col-xs-8 col-sm-6 col-md-4 col-lg-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "q-gutter-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('screen_text.alreadyActivated')) + " ", 1 /* TEXT */),
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(_component_q_btn, {
                class: "kerryButton",
                label: _ctx.$t('button.yes'),
                "no-caps": "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoToKerryHub()))
              }, null, 8 /* PROPS */, ["label"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_q_btn, {
                class: "kerryButton",
                label: _ctx.$t('button.no'),
                "no-caps": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GotoEmployeePromptForm()))
              }, null, 8 /* PROPS */, ["label"])
            ])
          ])
        ])
      ])
    ])
  ]))
}